/* globals flash */
/* eslint-disable class-methods-use-this */

import { lcfirst } from '../core/helpers';

class NotificationHandler {

  /**
   * Construct a new notification handler.
   *
   * @param notification
   */
  constructor(notification) {
    this.id = notification.id;
    this.type = lcfirst(notification.type.split('\\').pop());
    this.notification = notification;
  }

  /**
   * Dispatch the notification.
   *
   * @returns {*}
   */
  dispatch() {
    if (typeof this[this.type] === 'function') {
      return this[this.type]();
    }

    return console.warn(`No handler for notification of type ${this.type}`);
  }

  /**
   * Handle a CartsExpiringSoon notification.
   */
  cartsExpiringSoon() {
    const cartsCount = this.notification.carts.length;
    flash({ clean: true });
    setTimeout(() => flash({
      type: 'warn',
      title: 'Attention',
      text: cartsCount > 1 ? `${cartsCount} paniers vont bientôt expirer` : `${cartsCount} panier va bientôt expirer`,
      duration: -1,
    }), 500);
  }

}

export default NotificationHandler;
